module.exports = __webpack_public_path__ + "4545a912099fcb738a7954227503c950.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003ALY.png
// module id = 1508
// module chunks = 0